import { apiRequest } from "@/lib/queryClient";

const STORAGE_KEY = "ts_recent_photos";
const MIGRATED_KEY = "ts_recent_photos_migrated";
const MAX_STORAGE_ITEMS = 15;

export interface StoredPhoto {
  id: number;
  slug: string;
  title: string;
  imageUrl?: string;
  thumbUrl?: string;
  year?: number;
  viewedAt: number;
}

export function getRecentPhotosFromStorage(): StoredPhoto[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as StoredPhoto[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function savePhotoToStorage(photo: StoredPhoto): void {
  if (typeof window === "undefined") return;
  try {
    let list = getRecentPhotosFromStorage();
    list = list.filter((p) => p.id !== photo.id);
    list.unshift(photo);
    list = list.slice(0, MAX_STORAGE_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // ignore
  }
}

export async function migrateRecentPhotosFromStorage(): Promise<void> {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem(MIGRATED_KEY)) return;
  const list = getRecentPhotosFromStorage();
  if (list.length === 0) return;
  try {
    await apiRequest("POST", "/api/user/recent-photos/import", {
      photos: list.map((p) => ({ id: p.id, viewedAt: p.viewedAt })),
    });
    // Keep localStorage as UI fallback even after import
    sessionStorage.setItem(MIGRATED_KEY, "true");
  } catch (e) {
    console.warn("Failed to migrate recent photos:", e);
  }
}
